import { TApplicationState } from 'shared/types/redux';
import { hasValidPhone } from 'shared/utils/agent';

export const sellersSelector = (state: TApplicationState) => {
  return state.newbuilding.sellers;
};

export function sellersWithPhonesSelector(state: TApplicationState) {
  const {
    newbuilding: { sellers },
  } = state;

  if (sellers) {
    return sellers.filter(seller => seller.showPhone && seller.phone);
  }

  return [];
}

export function sellersWithValidPhonesSelector(state: TApplicationState) {
  const sellers = sellersSelector(state);

  return sellers.filter(hasValidPhone);
}
